import { render, staticRenderFns } from "./WaitingMessage.vue?vue&type=template&id=0240f194&"
import script from "./WaitingMessage.vue?vue&type=script&lang=js&"
export * from "./WaitingMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports